import React from 'react'
import './style.scss'
import { FiUser } from 'react-icons/fi'

function ButtonTab({ onClick, icon, nome, classAdd }) {
    return (
        <div onClick={onClick} className={`button button-tab ${classAdd}`}>
            {icon ? icon : <FiUser />}
            {nome && <span>{nome}</span>}
        </div>
    )
}

export default ButtonTab